import { envConfigSelectors } from '~/selectors';
import { SelectDateTime } from '~/routes';

export const config = {
  selectablePartnersTitle: 'Choose another stylist',
  SelectDate: {
    componentDecisioner: [
      {
        supports: envConfigSelectors.selectIsNewCalendarEnabled,
        component: SelectDateTime,
      },
    ],
  },
};
